export const formatPhone = (phone: string) => {
	return `55${phone.match(/\d+/g)?.join('')}`
}
